import { render, staticRenderFns } from "./ManPreventivaOsErp.vue?vue&type=template&id=7a4eff86&"
import script from "./ManPreventivaOsErp.vue?vue&type=script&lang=js&"
export * from "./ManPreventivaOsErp.vue?vue&type=script&lang=js&"
import style0 from "./ManPreventivaOsErp.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports